import config from '@/service/config'
import appConfig from '@/service/config'
import un from 'underscore'
import URLQueryBuilder from 'url-query-builder'

const escapeParam = function(param) {
  return encodeURIComponent(param)
}

var MainPresenter = function() {

  this.getUrlForData = function(form, pageableMainParams) {
    return this.getUrlForCommonData("/products", form, pageableMainParams);
  }

  this.getUrlForCsvData = function(form, pageableMainParams) {
    return this.getUrlForCommonData("/products/csv", form, pageableMainParams);
  }

  this.getUrlForCommonData = function(urlPrefix, form, pageableMainParams) {
    const q = new URLQueryBuilder(appConfig.baseUrl + urlPrefix)
    un.each(form, (value, key, list) => {
        q.set(key, escapeParam(value));
    });
    un.each(pageableMainParams, (value, key, list) => {
      q.set(key, value);
    });
    return q.get();
  }

  this.getUrlForParams = function(urlPrefix, params) {
    const q = new URLQueryBuilder(appConfig.baseUrl + urlPrefix)
    un.each(params, (value, key, list) => {
        q.set(key, escapeParam(value));
    });
    return q.get();
  }

  this.buildUrl = function(urlPrefix, params) {
    const q = new URLQueryBuilder(appConfig.baseUrl + urlPrefix)
    un.each(params, (value, key, list) => {
      q.set(key, value);
    });
    return q.get();
  }

  this.buildUrlWithDefaults = function(urlPrefix) {
    return this.buildUrl(urlPrefix, config.defaultQueryParams);
  }

  return {
    "getUrlForData": this.getUrlForData,
    "getUrlForCommonData": this.getUrlForCommonData,
    "buildUrl": this.buildUrl,
    "buildUrlWithDefaults": this.buildUrlWithDefaults,
    "getUrlForParams": this.getUrlForParams,
    "getUrlForCsvData": this.getUrlForCsvData
  }
}

export default MainPresenter;



// WEBPACK FOOTER //
// ./src/service/MainPresenter.js